import type { AppSettings, PlayerType } from '../types/app';

const PLAYER_TYPES: PlayerType[] = [
  'native',
  'videojs',
  'bitmovin',
  'shaka',
  'shaka-mt',
];

export const getPlayerType = (value: string | null): PlayerType =>
  PLAYER_TYPES.includes(value as PlayerType) ? (value as PlayerType) : 'native';

export const getAppSettings = (search: string): AppSettings => {
  const params = new URLSearchParams(search);
  const device = params.get('device') || 'tv';
  const homescreenSlug = params.get('homescreenSlug') || 'homescreen';

  return {
    device,
    isTv: device.toLowerCase() === 'tv',
    playerType: getPlayerType(params.get('player')),
    testingMode: params.get('testingMode') === 'true',
    homescreenSlug,
  };
};

export const getSdkSearchParams = (search: string): Record<string, string> => {
  const values: Record<string, string> = {};

  new URLSearchParams(search).forEach((value, key) => {
    values[key] = value;
  });

  return values;
};

export const getVirtualChannels = (search: string): string[] => {
  const value = new URLSearchParams(search).get('virtualChannels');

  if (!value) return [];

  try {
    const channels: unknown = JSON.parse(value);
    return Array.isArray(channels)
      ? channels.filter((item): item is string => typeof item === 'string')
      : [];
  } catch {
    return [];
  }
};

export const updateSearchParam = (
  search: string,
  key: string,
  value?: string,
): string => {
  const params = new URLSearchParams(search);

  if (value) params.set(key, value);
  else params.delete(key);

  const result = params.toString();
  return result ? `?${result}` : '';
};
